export { default as DataTable } from './DataTable';
export const DEFAULT_PAGE_SIZE = 20;
